import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { ListNav } from "@/components/ListNav";
import { useViewport } from "@/responsive/viewport";
import { useHelpNav } from "./helpNav";
import { useHelpArticles } from "./useHelpArticles";

/**
 * /help/*: topic nav column + page on desktop/tablet. On a phone the landing
 * page carries the topic list itself and articles have a back header, so the
 * layout adds nothing there.
 */
export function HelpLayout() {
  const { t } = useTranslation("help");
  const { isMobile } = useViewport();
  const articles = useHelpArticles();
  const groups = useHelpNav(articles);
  if (isMobile) return <Outlet />;
  return (
    <div className="flex min-h-full">
      <aside className="w-60 shrink-0 border-r border-border-subtle">
        <div className="sticky top-0 max-h-dvh overflow-y-auto px-3 py-8">
          <ListNav groups={groups} aria-label={t("nav.label")} />
        </div>
      </aside>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
